var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeeMore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7404 7.5558L13.5469 5.3623L8.74072 10.1685C7.91064 10.9985 7.09508 11.5298 6.26709 10.6997C5.43701 9.86963 5.96826 9.05615 6.79834 8.22607L11.6045 3.41992L9.4442 1.2586C8.97311 0.787512 9.37779 0 10.0751 0H15.7403C16.4355 0 17 0.563424 17 1.2586V6.92597C17 7.62115 16.2135 8.02788 15.7404 7.5558ZM2.125 14.875H12.75V8.6266L14.875 10.7516V14.875C14.875 16.0496 13.9246 17 12.75 17H2.125C0.950439 17 0 16.0496 0 14.875V4.25C0 3.07647 0.950439 2.125 2.125 2.125H6.24843L8.37343 4.25H2.125V14.875Z",
    fill: "#49712B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeeMore);
export default __webpack_public_path__ + "static/media/see-more.5541ae1fc499315c3df6d16196240996.svg";
export { ForwardRef as ReactComponent };